import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {CircularProgressBar} from '../../visualization';
import {Heading, Text} from 'components/styled';
import styled from 'styled-components';
import {commonLocalization, number, helpTextLocalization} from 'localization';
import { images } from "../../../config/index";

class ProjectProgressChart extends Component {
    state = {};

    getFragment(selectedWard, selectedLanguage) {
        if (selectedWard === 'all') return null;

        if (selectedLanguage === 'en') {
            return (
                <Fragment>
                    for <strong>Ward {number(selectedWard)}</strong>
                </Fragment>
            );
        }
        return (
            <Fragment>
                <strong>वडा {number(selectedWard)}</strong> का लागि
            </Fragment>
        );
    }

    render() {
        const {selectedWard, overall, ward_wise, selectedLanguage} = this.props;
        const {
            circularProgressBarTitle,
            physicalProgress,
            financialProgress
        } = commonLocalization[selectedLanguage];
        const {
            circularProgressBar: circularProgressBarHelpText
        } = helpTextLocalization[selectedLanguage];

        let physicalValue = 0;
        let financialValue = 0;

        const data = selectedWard === 'all' ? overall : ward_wise[selectedWard];

        if (data && Object.keys(data).length) {
            physicalValue = data.total.progress.physical;
            financialValue = data.total.progress.financial;
        }

        return (
            <ChartsBlock className="charts-block flex flex-col " lang={selectedLanguage}>
                <Heading.h2 uppercase style={{marginBottom: 8}} className="flex items-center">
                    <Text.span className="help-text">
                        <Text.span className="help-text__icon"><img className="help-icon" height={18} width={18} src={images.icons.help} alt="help" /></Text.span>
                        <Text.span className="help-text__content tooltip">
                            <Text.span className="tooltip-arrow">arrow</Text.span>
                            {circularProgressBarHelpText}
                        </Text.span>
                    </Text.span>
                    <Text.span>
                        {selectedLanguage === 'en' && `${circularProgressBarTitle} `}
                        {this.getFragment(selectedWard, selectedLanguage)}
                        {selectedLanguage === 'np' && ` ${circularProgressBarTitle}`}
                    </Text.span>
                </Heading.h2>
                <div className="card--chart chart--progress flex justify-center items-center flex-1">
                    <ProjectsCircular className={'flex  flex-wrap w-full'}>
                        <div>
                            <CircularProgressBar value={physicalValue}/>
                            <Text.span lighter uppercase>
                                {physicalProgress}
                            </Text.span>
                        </div>
                        <div>
                            <CircularProgressBar value={financialValue}/>
                            <Text.span lighter uppercase>
                                {financialProgress}
                            </Text.span>
                        </div>
                    </ProjectsCircular>
                </div>
            </ChartsBlock>
        );
    }
}

const mapStateToProps = state => ({
    selectedWard: state.projectsStatsReducers.selectedWard,
    overall: state.projectsStatsReducers.data.data.overall,
    ward_wise: state.projectsStatsReducers.data.data.ward_wise,
    selectedLanguage: state.localizationReducers.selectedLanguage
});

const ProjectsCircular = styled.div`
  display: flex;
  justify-content: space-around;
  > div {
    text-align: center;
    > div {
      margin-bottom: 10px;
    }
  }
`;

const ChartsBlock = styled.div`
  h2 {
    > span:last-child {
      font-size: ${props => (props.lang === 'en' ? '12px' : '14px')};
      opacity: 0.7;
    }
  }
  div span {
    font-size: ${props => (props.lang === 'en' ? '12px' : '14px')};
  }
`;

export default connect(mapStateToProps)(ProjectProgressChart);



// WEBPACK FOOTER //
// ./src/components/layouts/projectProgressChart/projectProgressChart.js